import { RotateRightIcon } from './RotateRightIcon';

/**
 * author: Google
 * id 5324E881-FACF-4CAC-9118-FD963EDCDD27
 * name rotate-right
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rotate-right.svg
 * tags
 * - Arrow 
 */
export const ArrowRotateRightIcon = RotateRightIcon;
export default ArrowRotateRightIcon